var Themeparks = require('themeparks');
var moment = require('moment-timezone');

moment.tz.setDefault('America/New_York');

export function includeDestination(destination) {
    // Destinations to include
    var destinations = [
        'waltdisneyworldresort',
        'universalorlando'
    ];

    return destinations.includes(destination.slug);
}

export function filterParks(type) {
    document.querySelectorAll('.park-section').forEach(section => {
        if (type === 'all') {
            section.style.display = 'block';
        } else if (section.classList.contains(type)) {
            section.style.display = 'block';
        } else {
            section.style.display = 'none';
        }
    });

    localStorage.setItem('destinations_filter', type)
}

export function humanReadableEntityStatus(status) {
    if (status == 'OPERATING') {
        return 'Open';
    } else if (status == 'CLOSED') {
        return 'Gesloten';
    } else if (status == 'DOWN') {
        return 'Storing';
    } else if (status == 'REFURBISHMENT') {
        return 'Onderhoud';
    }

    return status;
}

export function shortenDestinationName(destination) {
    if (destination.slug == 'waltdisneyworldresort') {
        return 'Walt Disney World';
    } else if (destination.slug == 'universalorlando') {
        return 'Universal Orlando';
    }

    return destination.name;
}

export async function parkHoursStringToday(park, types) {
    return await parkHoursString(park, moment(), types)
}

export async function parkHoursString(park, date, types) {
    var parkHoursLabels = []

    await parkHoursForDate(park, date, types).then(function (operatingHours) {
        operatingHours.forEach( function(operatingHour) {
            parkHoursLabels.push( operatingHour.hours )
        } );
    })

    return parkHoursLabels.join(' & ')
}

export async function parkHoursForToday(park, types) {
    return await parkHoursForDate(park, moment(), types)
}

export async function parkHoursForDate(park, date, types) {
    var operatingHours = []

    var entitiesApi = new Themeparks.EntitiesApi();

    const entitySchedule = await entitiesApi.getEntityScheduleUpcoming(park.id);

    entitySchedule.schedule.forEach(function (schedule) {
        if (schedule.date == date.format('YYYY-MM-DD') && types.includes(schedule.type)) {
            operatingHours.push({
                'type': schedule.type,
                'hours': moment(schedule.openingTime).format('HH:mm') + ' - ' + moment(schedule.closingTime).format('HH:mm'),
                'description': schedule.description,
            });
        }
    });

    return operatingHours
}

export function entityStandyByWaitingTime(entity) {
    if (entity.queue && entity.queue.STANDBY && entity.queue.STANDBY.waitTime) {
        return entity.queue.STANDBY.waitTime
    }
}

export function entitySorting(entity) {
    // Check entity type
    if (entity.entityType == 'ATTRACTION') {
        // Check status
        if (entity.status == 'OPERATING') {
            return entityStandyByWaitingTime(entity) ? entityStandyByWaitingTime(entity) : 0
        } else if (entity.status == 'CLOSED') {
            return -2;
        } else if (entity.status == 'DOWN') {
            return -1;
        } else if (entity.status == 'REFURBISHMENT') {
            return -3;
        }
    } else if (entity.entityType == 'SHOW') {
        if (showIsNotOverYet(entity)) {
            // Get next show time
            var nextShowTime = null

            if (entity.showtimes && entity.showtimes.length > 0) {
                entity.showtimes.forEach(function (showTime) {
                    if (nextShowTime === null && showTimeIsNotOverYet(showTime)) {
                        nextShowTime = moment(showTime.startTime).format('X')
                    }
                })
            }

            return nextShowTime ? nextShowTime : 99999999999999
        }

        return 99999999999999
    }

    return 0
}

export function showTimeIsNotOverYet(showTime) {
    if (showTime.endTime) {
        return moment(showTime.endTime).isAfter(moment())
    }

    return moment(showTime.startTime).isAfter(moment())
}

export function showIsNotOverYet(entity) {
    var showHasUpcomingShowTime = false

    if (entity.showtimes && entity.showtimes.length > 0) {
        entity.showtimes.forEach(function (showTime) {
            if (showTimeIsNotOverYet(showTime)) {
                showHasUpcomingShowTime = true
            }
        })
    }

    return showHasUpcomingShowTime
}

export function operatingHoursToShowTimes(entity) {
    var showTimes = []

    entity.operatingHours.forEach(function (operatingHour) {
        showTimes.push(operatingHour)
    })

    return showTimes
}

export function entityHasQueueReturnTime(entity) {
    if (entity.queue && entity.queue.RETURN_TIME) {
        return true
    }

    return false
}

export function entityHasQueuePaidReturnTime(entity) {
    if (entity.queue && entity.queue.PAID_RETURN_TIME) {
        return true
    }

    return false
}

export function formatPaidReturnPrice(entity) {
    var output = ''

    // Add currency
    if (entity.queue.PAID_RETURN_TIME.price.currency == 'USD') {
        output += '$'
    } else if (entity.queue.PAID_RETURN_TIME.price.currency == 'EUR') {
        output += '€ '
    }

    // Add price
    output += (entity.queue.PAID_RETURN_TIME.price.amount / 100).toFixed(2).replace('.00', '')

    return output
}

export function entityOperatingHours(entity, types) {
    // Get operating hours
    var operatingHours = []

    if (entity.operatingHours) {
        entity.operatingHours.forEach(function (operatingHour) {
            if (types.includes(operatingHour.type.toUpperCase().replace(' ', '_'))) {
                if (operatingHour.endTime && (moment(operatingHour.startTime).format() != moment(operatingHour.endTime).format())) {
                    operatingHours.push({
                        'type': operatingHour.type,
                        'hours': moment(operatingHour.startTime).format('HH:mm') + ' - ' + moment(operatingHour.endTime).format('HH:mm'),
                    });
                } else {
                    operatingHours.push({
                        'type': operatingHour.type,
                        'hours': 'Vanaf ' + moment(operatingHour.startTime).format('HH:mm'),
                    });
                }
            }
        });
    }

    return operatingHours
}

export function entityHasForecastedWaitingTimes(entity) {
    if (entity.forecast && entity.forecast.length > 0) {
        return true
    }

    return false
}

export function lowestForecast(entity) {
    // Sort forecasts by waiting time
    entity.forecast.sort((a, b) => a.waitTime - b.waitTime)

    return entity.forecast[0]
}

export function hiddenParksFromStorage() {
    return localStorage.getItem('hidden_parks') !== null ? JSON.parse(localStorage.getItem('hidden_parks')) : []
}

export function storeHiddenParksToStorage(hiddenParks) {
    localStorage.setItem('hidden_parks', JSON.stringify(hiddenParks))
}

export function hidePark(park) {
    // Get hidden parks from local storage
    var hiddenParks = hiddenParksFromStorage()

    // Check if park is currently hidden
    if (!hiddenParks.includes(park.id)) {
        // Add new hidden park
        hiddenParks.push(park.id)
    }

    // Store hidden parks
    storeHiddenParksToStorage(hiddenParks)
}

export function unhidePark(park) {
    // Get hidden parks from local storage
    var hiddenParks = hiddenParksFromStorage()

    // Check if park is currently hidden
    if (hiddenParks.includes(park.id)) {
        hiddenParks.splice(hiddenParks.indexOf(park.id), 1);
    }

    // Store hidden parks
    storeHiddenParksToStorage(hiddenParks)
}

export function humanReadableScheduleType(type) {
    if (type == 'OPERATING') {
        return 'Open';
    } else if (type == 'TICKETED_EVENT') {
        return 'Betalend event';
    } else if (type == 'PRIVATE_EVENT') {
        return 'Privaat event';
    } else if (type == 'EXTRA_HOURS') {
        return 'Extra uren';
    } else if (type == 'INFO') {
        return 'Info';
    }

    return type;
}